import {isNull, isSuperuser} from "../../../utils/utils";
import {aclPermissions, hasPermissions} from "../../../const/ACLPermissions";

export const checkAppPermission = app => {
    if (isNull(aclPermissions[app.id])) {
        return app.defaultPermission || false;
    }
    app.permission = isSuperuser() ? true : hasPermissions([app.id])
    return app.permission;
}
